/**
 * Created by Vladislav on 25.09.2024.
 */

const LivesMenuBarItem = { 
    name: "LivesItem",
    targets: "lives",
    muteRegenerateLivesSound: () => cleverapps.Lives.IsLocationWithEnergy(),
    isClickable: function () {
        return cleverapps.flags.monetization !== cleverapps.Flags.MONETIZATION_DISABLED;
    },
    plusButton: function () {
        return connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB) ? undefined : true;
    },
    attentionUpdater: function (f) {
        if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && Map2dLocation.currentLocation.energyLottery) {
            Map2dLocation.currentLocation.energyLottery.onLotteryAttentionChanged = f;
        }
    },
    attention: function () {
        if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && Map2dLocation.currentLocation.energyLottery) {
            return Map2dLocation.currentLocation.energyLottery.isReady();
        }
    },
    availableOnScenes: function () {
        const scenes = [cleverapps.Environment.SCENE_BONUS_WORLD];

        const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;

        if (locationConfig.isMain || locationConfig.usesEnergy) {
            scenes.push(cleverapps.Environment.SCENE_MAIN);
        }

        if (cleverapps.dailyCup && cleverapps.dailyCup.withLives()) {
            scenes.push(cleverapps.Environment.SCENE_DAILY_CUP);
        }

        scenes.push(cleverapps.Environment.SCENE_WEEKLY_TOURNAMENT);

        return scenes;
    },
    force: Forces.BUY_ENERGY_ICON,
    viewClass: MenuBarWithTimeoutView,
    modelClass: LivesMenuBarItemModel,
    icon: function () {
        return cleverapps.skins.getSlot("menubar_life_png") || bundles.menubar.frames.menubar_life_png;
    },
    onClickWindow: () => (cleverapps.lives.isWithEnergy() ? EnergyShopWindow : LivesShopWindow),
    filter: function () {
        if (cleverapps.unlimitedLives && cleverapps.unlimitedLives.freeOfferIsAvailable()) {
            cleverapps.unlimitedLives.showFreeOffer(() => {});
            return false;
        }

        if (cleverapps.lives.hasUnlimitedLives() || (cleverapps.config.name === "riddles" && connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB))) {
            return false;
        }
        return true;
    },
    sparks: true,
    incEffect: () => (cleverapps.config.features.includes("lives") ? "menubar.lives.fly_finish"
        : cleverapps.skins.getSlot("inc_energy_effect") || "menubar.energy.inc"),
    decEffect: () => (cleverapps.config.features.includes("lives") ? "menubar.lives.fly_finish"
        : cleverapps.skins.getSlot("dec_energy_effect") || "menubar.energy.dec"),

    onDebugClick: function () {
        cleverapps.lives.setAmount(cleverapps.lives.getMaxLives());
    }
};
